<div class="generic-multiselect-wrapper">
    <p-multiselect #genericMultiSelect
                   stopOnOptionSelectPropagation
                   preserveSelection
                   [id]="id"
                   [options]="options"
                   [placeholder]="config.placeholder || placeholder"
                   [class.hide-placeholder]="config.placeholderSubstitute && value.length === 0 && placeholderSubstituteTemplate"
                   optionLabel="label"
                   optionValue="value"
                   [disabled]="disabled"
                   [filter]="filter"
                   filterBy="label"
                   (onFilter)="onFilter($event)"
                   [virtualScroll]="computedVirtualScroll"
                   [lazy]="computedLazy"
                   [virtualScrollItemSize]="virtualScrollItemSize"
                   [virtualScrollOptions]="virtualScrollOptions"
                   [loading]="loading"
                   [appendTo]="appendTo"
                   [styleClass]="styleClass"
                   [showClear]="showClear"
                   [display]="display"
                   [ngModel]="value"
                   (ngModelChange)="onValueChange($event)">

    <!-- Custom templates -->
    <ng-template let-items pTemplate="selecteditems">
        <ng-container *ngIf="selectedItemTemplate; else builtInSelectedItem">
            <ng-container *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: items }"></ng-container>
        </ng-container>
        <ng-template #builtInSelectedItem>
            <ng-container [ngSwitch]="config.templateName">
                <!-- Skill template -->
                <div *ngSwitchCase="'skill'" class="flex items-center gap-2 w-full">
                    <generic-p-tag *ngFor="let item of items" [value]="item.value" type="skill" styleClass="w-fit" />
                </div>
                <!-- Employee Position Status template -->
                <div *ngSwitchCase="'employeePositionStatus'" class="flex items-center gap-2 w-full">
                    <generic-p-tag *ngFor="let item of items" [value]="item.value" type="employeePositionStatus" styleClass="w-fit" />
                </div>
                <!-- Learner template -->
                <div *ngSwitchCase="'learner'" class="flex items-center gap-2 flex-wrap w-full">
                    <p-tag *ngFor="let item of items" [value]="item.code + ' - ' + item.fullname" severity="secondary" />
                </div>
                <!-- Employee template -->
                <div *ngSwitchCase="'employee'" class="flex items-center gap-2 flex-wrap w-full">
                    <p-tag *ngFor="let item of items" [value]="item.code + ' - ' + (item.fullname || 'N/A') + ' (' + item.nickname + ')'" severity="success" />
                </div>
                <!-- Assignee template (with avatars only) -->
                <div *ngSwitchCase="'assignee'" class="flex items-center gap-2 flex-wrap w-full">
                    <div *ngFor="let item of items" class="rounded-full bg-primary text-white flex items-center justify-center font-semibold w-8 h-8 text-xs">
                        {{ getUserInitials(item) }}
                    </div>
                </div>
                <!-- Default template -->
                <div *ngSwitchDefault>
                    <div *ngFor="let item of items">{{ item.label }}
                    </div>
                </div>
            </ng-container>
        </ng-template>
    </ng-template>

    <ng-template let-item #item>
        <ng-container *ngIf="itemTemplate; else builtInItem">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>
        <ng-template #builtInItem>
            <ng-container [ngSwitch]="config.templateName">
                <!-- Skill template -->
                <div *ngSwitchCase="'skill'" class="flex items-center gap-2 w-full">
                    <generic-p-tag [value]="item.value" type="skill" styleClass="w-fit" />
                </div>
                <!-- Employee Position Status template -->
                <div *ngSwitchCase="'employeePositionStatus'" class="flex items-center gap-2 w-full">
                    <generic-p-tag [value]="item.value" type="employeePositionStatus" styleClass="w-fit" />
                </div>
                <!-- Learner template -->
                <div *ngSwitchCase="'learner'" class="flex items-center gap-2 w-full">
                    <p-tag [value]="item.code + ' - ' + item.fullname" severity="secondary" />
                </div>
                <!-- Employee template -->
                <div *ngSwitchCase="'employee'" class="flex items-center justify-between gap-2 w-full">
                    <div class="flex items-center gap-2">
                        <p-tag [value]="item.code" severity="success" />
                        <span>{{ item.fullname || 'N/A' }}</span>
                    </div>
                    <span class="italic text-gray-600">{{ item.nickname }}</span>
                </div>
                <!-- Assignee template (same as employee for items) -->
                <div *ngSwitchCase="'assignee'" class="flex items-center justify-between gap-2 w-full">
                    <div class="flex items-center gap-2">
                        <p-tag [value]="item.code" severity="success" />
                        <span>{{ item.fullname || 'N/A' }}</span>
                    </div>
                    <span class="italic text-gray-600">{{ item.nickname }}</span>
                </div>
                <!-- Default template -->
                <div *ngSwitchDefault>{{ item.label }}</div>
            </ng-container>
        </ng-template>
    </ng-template>

    <ng-template #empty>
        <ng-container *ngIf="loading; else noResults">
            <span class="italic">Loading — please wait…</span>
        </ng-container>
        <ng-template #noResults>
            <span class="italic">No results found.</span>
        </ng-template>
    </ng-template>
</p-multiselect>

    <!-- Placeholder Substitute Template -->
    <ng-container *ngIf="config.placeholderSubstitute && value.length === 0 && placeholderSubstituteTemplate">
        <div class="placeholder-substitute">
            <ng-container *ngTemplateOutlet="placeholderSubstituteTemplate"></ng-container>
        </div>
    </ng-container>
</div>